import { connect } from 'redux-bundler-react';

import { Grid, GridContainer } from '@trussworks/react-uswds';
import './home.scss';
import ModuleButton from '@pages/Resources/components/_shared/ModuleButton';
import NewApplicationModal from './components/modals/NewApplication';
import { mdiFileEditOutline, mdiFileQuestionOutline, mdiViewDashboardVariantOutline } from '@mdi/js';
import { useModal, useUserRoleCapabilities } from '@stores';
import { useNavigate } from '@tanstack/react-router';
import ExternalLink from '@src/app-components/external-link/ExternalLink';

const rowProps = {
  row: true,
  gap: 'md',
};

const cellProps = {
  desktop: { col: 4 },
  tablet: { col: 6 },
  style: { marginBottom: '1rem' },
};

const Home = connect('doResetReduxFormData', ({ doResetReduxFormData }) => {
  const { openModal } = useModal();
  const navigate = useNavigate();
  const canCreateRequest = useUserRoleCapabilities((state) => state.roleCapabilities.createRequest);
  const canViewDashboard = useUserRoleCapabilities((state) => state.roleCapabilities.viewDashboard);
  const handleButtonClick = (modal) => {
    doResetReduxFormData();
    openModal(modal);
  };

  return (
    <div className='card-menu-container'>
      <div className='hero-container requests'>
        <div className='hero-image' />
        <h1>Regulatory Request System (RRS)</h1>
        <div className='hero-description'>
          The purpose of this system is to accept electronic submittals of information, Department of the Army permit
          applications, requests for jurisdictional determinations, requests for preapplications, and comments on
          projects from the regulated public and resource agencies in one portal. Applicants or agents can also view
          general information about the Regulatory Program and check on the status of their requests.
        </div>
        <div className='hero-description'>
          <ExternalLink href='https://youtu.be/4uuTxPGHBMM'>
            View this video demonstration of how to start a new request and the three different options available to
            users for entering the project location.
          </ExternalLink>
        </div>
        <div className='hero-content'>
          <h3>Select an option below to get started: </h3>
        </div>
      </div>
      <GridContainer>
        <Grid {...rowProps}>
          <Grid {...cellProps}>
            <ModuleButton
              title='Start a Request'
              imageAlt='Start a Request'
              text='Submit a Permit Application or other request to the USACE Regulatory Program.'
              icon={mdiFileEditOutline}
              onClick={() => handleButtonClick(NewApplicationModal)}
              isDisabled={!canCreateRequest}
            />
          </Grid>
          <Grid {...cellProps}>
            <ModuleButton
              title={"I'm Not Sure"}
              imageAlt={"I'm Not Sure"}
              text='Answer a few quick questions to help determine which type of request to submit'
              icon={mdiFileQuestionOutline}
              onClick={() => navigate({ to: '/home/permit-process-guide' })}
            />
          </Grid>
          <Grid {...cellProps}>
            <ModuleButton
              title='My Dashboard'
              imageAlt='My Dashboard'
              text='View Submitted/Edit Draft Requests'
              icon={mdiViewDashboardVariantOutline}
              onClick={() => navigate({ to: '/dashboard' })}
              isDisabled={!canViewDashboard}
            />
          </Grid>
        </Grid>
      </GridContainer>
    </div>
  );
});

export default Home;
